// ════════════════════════════════════════════════════════════════════════
// ToolRail — NEW (Coach Review v2 layout).
// ────────────────────────────────────────────────────────────────────────
// The v2 right rail's upper section — a passthrough container for the
// canvas's own drawing controls. It does NOT re-implement, and does
// NOT re-label, the tool grid / color palette / stroke slider: those
// are the existing canvas primitives (ToolGrid / ColorPalette /
// StrokeWidthSlider), handed in via the canvas's `toolRailSlot`
// render-prop (see `TelestratorCanvasProps.toolRailSlot`). Each of
// those primitives ALREADY renders its own "Tools" / "Color" /
// "Stroke" section label, so this wrapper deliberately adds none —
// an extra heading here produced a duplicated "Tools" label.
//
// Keeping the canvas's real controls (rather than rebuilding them)
// means the tool state, color, stroke, focus ring, and per-surface
// validity all stay correct for free — the controls drive the same
// `review-editor` store whether they sit in the canvas column or
// here. No new tokens, no rebuilt primitives.
// ════════════════════════════════════════════════════════════════════════

export type ToolRailProps = {
  /** The canvas's tool grid / color / stroke controls, passed
   * through the canvas's `toolRailSlot`. */
  children: React.ReactNode;
};

export function ToolRail({ children }: ToolRailProps) {
  return (
    <div
      className="flex flex-col gap-4"
      data-testid="coach-review-tool-rail"
    >
      {children}
    </div>
  );
}
